/**
 * EditReasonModal - Модальное окно для ввода причины редактирования
 */
import React, { useState } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Text,
  Alert,
} from '@mantine/core';
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react';

const EditReasonModal = ({
  opened,
  onClose,
  onConfirm,
  loading = false,
  title = 'Укажите причину изменения',
  entityName = 'запись',
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Пожалуйста, укажите причину изменения');
      return;
    }
    setError(null);
    onConfirm(reason.trim());
  };

  const handleClose = () => {
    setReason('');
    setError(null);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={title}
      size="md"
      radius="xl"
      styles={{
        content: {
          borderRadius: '16px',
        },
      }}
    >
      <Stack gap="md">
        <Alert
          icon={<IconAlertTriangle size={16} />}
          color="yellow"
          variant="light"
        >
          <Text size="sm">
            Вы собираетесь изменить {entityName}. Пожалуйста, укажите причину изменения.
            Эта информация будет сохранена в истории изменений.
          </Text>
        </Alert>

        {error && (
          <Alert color="red" variant="light">
            {error}
          </Alert>
        )}

        <Textarea
          label="Причина изменения"
          placeholder="Опишите, почему необходимо изменить эту запись..."
          required
          autosize
          minRows={4}
          maxRows={8}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={error ? ' ' : null}
        />

        <Group justify="flex-end" mt="md">
          <Button variant="subtle" onClick={handleClose} disabled={loading}>
            Отмена
          </Button>
          <Button
            color="yellow"
            leftSection={<IconCheck size={16} />}
            onClick={handleConfirm}
            loading={loading}
          >
            Подтвердить изменение
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default EditReasonModal;
